import React from "react";
import s from "~/components/_uikit/Search/Search.module.scss";

export interface SearchProps {
  value: string;
  placeholder: string;
  onChange: (event: any) => void;
  onSubmit: (event: any) => void;
  onBlur?: (event: any) => void;
}

const Search: React.FC<SearchProps> = ({
  placeholder,
  value,
  onSubmit,
  onChange,
  onBlur = () => ({}),
}) => {
  const handleSubmit = (event: any) => {
    event.preventDefault();
    onSubmit(event.target.search.value);
  };

  const handleChange = (event: any) => {
    event.preventDefault();
    onChange(event.target.value);
  };

  const handleBlur = (event: any) => {
    onBlur(event.target.value);
  };

  return (
    <div className={s.search}>
      <div className="screen-container">
        <form className={s.searchForm} onSubmit={handleSubmit}>
          <div className={s.searchIconWrap}>
            <img
              className={s.searchIcon}
              src="https://onlinezdrav.ru/assets/location.svg"
              alt="Маркер"
            />
          </div>

          <input
            autoComplete="off"
            name="search"
            type="text"
            className={`${s.searchInput} ${s.searchLocation}`}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <div className={s.searchButtonWrap}>
            <button type="submit" className={s.searchButton}>
              <img
                src="https://onlinezdrav.ru/assets/search-icon-light.svg"
                alt="Лупа"
              />
              <span>НАЙТИ</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Search;
